const getTokens = (inputString) => {
  return inputString
    .toLowerCase()
    .split(/(\s)/)
    .filter((token) => token !== " " && token !== "");
};

const hasPartialMatches = (firstArray, secondArray) => {
  // Iterate over each token in the second array
  return secondArray.every((secondToken) => {
    // Check if there is any token in the first array that includes the current token
    return firstArray.some((firstToken) => firstToken.includes(secondToken));
  });
};

export function filterGames(games, filterText) {
  const filterTokens = getTokens(filterText);
  return games.filter(({ name, categories, mechanics }) => {
    const tokens = getTokens(name)
      .concat(getTokens(categories.flat().toString()))
      .concat(getTokens(mechanics.flat().toString()));

    return hasPartialMatches(tokens, filterTokens);
  });
}
